import * as React from "react";
import axiosInstance from "../../Api/Axios";

import Select from "../../Components/Select";

const Motive = (props) => {
  const { ...rest } = props;

  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/leasing-contact-advisor-types`)
      .then((response) => {
        setData(response.data?.data || []);
      });
  }, []);

  return (
    <Select {...rest}>
      <option value=""></option>
      {data.map((motive) => {
        return (
          <option key={motive.id} value={motive.id}>
            {motive.name}
          </option>
        );
      })}
    </Select>
  );
};

export default Motive;
